<template>
    <el-dialog
            :title="'修改应用'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="110px" class="two-item-form">
            <el-form-item label="名称" prop="name" class="single-item">
                <el-input v-model="dataForm.name" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item label="菜单类型:" prop="menuType">
                <el-select v-model="dataForm.menuType" placeholder="是否启动"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in menuTypeOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否启动" prop="enabled">
                <el-select v-model="dataForm.enabled" placeholder="是否启动"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="图标" prop="icon">
                <el-input v-model="dataForm.icon" placeholder="图标"></el-input>
            </el-form-item>
            <el-form-item label="排序:" prop="sort">
                <el-input v-model="dataForm.sort" placeholder="排序"></el-input>
            </el-form-item>
            <el-form-item label="菜单地址/事件:" class="single-item" prop="url">
                <el-input v-model="dataForm.url" placeholder="菜单地址/事件"></el-input>
            </el-form-item>
            <el-form-item label="授权标识:" class="single-item" prop="permissionCode">
                <el-input v-model="dataForm.permissionCode" placeholder="授权标识"></el-input>
            </el-form-item>
            <el-form-item label="路由名称:" prop="routeName">
                <el-input v-model="dataForm.routeName" placeholder="路由名称"></el-input>
            </el-form-item>
            <el-form-item label="路由参数:" prop="routeArg">
                <el-input v-model="dataForm.routeArg" placeholder="路由参数"></el-input>
            </el-form-item>
            <el-form-item label="描述:" prop="remark" class="single-item">
                <el-input type="textarea" v-model="dataForm.remark" placeholder="描述"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                dataForm: {
                    appId:'',
                    id:'',
                    parentId:'',
                    menuType :0,
                    name: "",
                    sort: 10,
                    routeArg: '',
                    routeName: '',
                    permissionCode: '',
                    url: "",
                    enabled:true,
                    icon: '',
                    remark: '',
                },
                trueOrFalseOptions:[{'text':'否','value':false},{'text':'是','value':true}],
                menuTypeOptions:[{'text':'菜单分组','value':0},{'text':'菜单地址','value':1},{'text':'功能按钮','value':99}],
                rules: {
                    name: [
                        {required: true, message: '名称不能为空', trigger: 'blur'},
                    ],
                    url: [
                        {required: true, message: 'URL不能为空', trigger: 'blur'},
                    ],
                    permissionCode: [
                        {required: true, message: '权限码不能为空', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            resetForm() {
                this.$refs['dataForm'].resetFields();
            },
            init(id,appId,parentId) {
                if(parentId===undefined){
                    parentId=''
                }
                this.dataForm.id = ''
                this.dataForm.appId = appId
                this.dataForm.parentId = parentId
                this.visible = true
                this.$nextTick(() => {
                    this.resetForm()
                })
                if(id==''|| id===undefined){
                    return
                }
                this.$http.get(`/auth/menus/getpermission?id=` + id, {}).then(({data}) => {
                    if (data && data.code === '1') {
                        let data2 = data.data
                        this.dataForm =data2
                    }
                })
            },
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return
                    }
                    this.dataSubmit()
                })
            },
            // 表单提交
            dataSubmit() {
                this.$http({
                    url: '/auth/menus/save',
                    method: 'post',
                    data: this.dataForm
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList',this.dataForm.id!=='' && this.dataForm.id!==undefined)
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-select{
        width: 100%;
    }
</style>
